import { defineComponent as n } from "vue";
import { useNavigationEventBus as t } from "@ado/acs-standard-library";
const a = n({
  name: "SocialLinks",
  setup() {
    return { navigationEventBus: t() };
  }
});
export {
  a as default
};
//# sourceMappingURL=index21.js.map
